/**
 * JS enabled
 */

export default () => {
    document.documentElement.classList.add('jmulib-js');
}
